"use client";

import formatDate from "@/util/formatDate";
// import queryMutation from "./query-mutation";

const hcpSignupQuery = ({
  first_name,
  last_name,
  // consumer_type,
  email,
  answer_text,
  agreement,
  npi_id,
  zip,
  phone_number,
  stay_informed,
  schedule_visit
}) => {
  // Determine HCP request type
  const hcp_request = stay_informed && schedule_visit 
    ? "schedule visit or call, stay informed"
    : schedule_visit 
    ? "schedule visit or call"
    : stay_informed 
    ? "stay informed"
    : undefined;

  // Slalom API query for the HCP signup form
  const date = formatDate();

  const mutationVariables = {
    // consumer_type,
    first_name,
    last_name,
    primary_specialty: answer_text,
    email_address: email,
    country_code: "US",
    email_opt_in_datetime: date,
    created_datetime: date,
    npi_id,
    postal_code: zip,
    contact_type: "HCP",
    source_name: "StudioRx",
    source_record_id: Date.now().toString(36) + Math.random().toString(36).substring(2, 12).padStart(12, '0'),
    business_unit: "Crenessity_HCP",
    indication: "CAH",
    is_branded_flag: "True",
    language: "English",
    email_opt_in_flag: agreement ? "True" : "False",
    opt_source: "Crenessity.com-Signup",
    crnhcp_request_for: hcp_request
  }

  if ( phone_number !== '') {
    mutationVariables.work_phone = phone_number.replace(/[^0-9]/g, '');
  }
  
  return mutationVariables;
};

export default hcpSignupQuery;